import React from "react";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import SelectionCardCst from "@components/SelectionCardCst";
import { SelectionGridProps } from "./types";

const DEFAULT_COLUMNS = { xs: 12, sm: 6, md: 4, lg: 4, xl: 4 };

const SelectionGridCst: React.FC<SelectionGridProps> = ({
  title,
  options,
  selectedKey,
  onSelect,
  columns,
}) => {
  const theme = useTheme();
  const col = { ...DEFAULT_COLUMNS, ...(columns || {}) };

  return (
    <Box sx={{ width: "100%" }}>
      {title && (
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: 700,
            color: theme.palette.text.primary,
            mb: 2,
          }}
        >
          {title}
        </Typography>
      )}
      <Grid container spacing={2}>
        {options.map((option) => (
          <Grid
            key={option.key}
            item
            xs={col.xs}
            sm={col.sm}
            md={col.md}
            lg={col.lg}
            xl={col.xl}
          >
            <SelectionCardCst
              title={option.title}
              description={option.description}
              selected={selectedKey === option.key}
              disabled={option.disabled}
              onSelect={() => onSelect(option.key)}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SelectionGridCst;
